// extracted by mini-css-extract-plugin
export default {"milestoneLink":"DemilestonedEvent-module__milestoneLink__qk8ztds"};